<template>
  <div class="piczoom">
    <div class="piczoom-img-box">
      <slot></slot>
      <!-- 鼠标层罩 -->
      <div v-show="topShow" class="piczoom-top" :style="topStyle"></div>
      <!-- 最顶层覆盖了整个原图空间的透明层罩 -->
      <div
        @dblclick="setBig"
        class="piczoom-masktop"
        @mouseenter="enterHandler"
        @mousemove="moveHandler"
        @mouseout="outHandler"
      ></div>
      <div
        v-show="rShow"
        class="piczoom-right"
        :style="{ transform: `translateX(${margin}px)` }"
      >
        <img :style="r_img" class="piczoom-right-img" :src="src" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default:'static/image/test.png'
    },
    margin: {
      //放大镜显示框与原图 间距
      type: [String, Number],
      default: 8
    },
    zoom: {
      //放大镜，放大倍数
      type: [String, Number],
      default: 8
    }
  },
  data() {
    return {
      topStyle: {
        transform: ''
      },
      r_img: {},
      topShow: false,
      rShow: false,
      piczoomWidth: 0,
      piczoomHeight: 0,
      picWidth: 0,
      picHeight: 0,
      piczoomTranslateX: null
    };
  },
  methods: {
    setBig() {
      this.$store.commit('set_dbClickImg', this.src);
    },
    // 鼠标进入原图空间函数
    enterHandler() {
      // 层罩及放大空间的显示
      this.topShow = true;
    },
    // 鼠标移动函数
    moveHandler(event) {
      this.rShow = true;

      // if(this.piczoomTranslateX===null){
      //     var strResult = document.defaultView.getComputedStyle(document.querySelector(".piczoom-right"),null).transform;
      //     var arr = strResult.split(",");
      //     this.piczoomTranslateX = parseInt(arr[4])
      //     console.log(this.piczoomTranslateX);
      // }
      // 鼠标的坐标位置
      let x = event.offsetX;
      let y = event.offsetY;
      // 层罩的左上角坐标位置，并对其进行限制：无法超出原图区域左上角
      let topX = x - this.piczoomWidth / 2 < 0 ? 0 : x - this.piczoomWidth / 2;
      let topY =
        y - this.piczoomHeight / 2 < 0 ? 0 : y - this.piczoomHeight / 2;
      // 对层罩位置再一次限制，保证层罩只能在原图区域空间内
      if (topX > this.picWidth - this.piczoomWidth) {
        // -10是 .right 的translateX(20px) 的一半
        topX = this.picWidth - this.piczoomWidth;
      }
      if (topY > this.picHeight - this.piczoomHeight - 0) {
        topY = this.picHeight - this.piczoomHeight - 0;
      }
      // 通过 transform 进行移动控制
      this.topStyle.transform = `translate(${topX}px,${topY}px)`;
      this.r_img.transform = `translate(-${(this.zoom / 2) * topX}px,-${
        (this.zoom / 2) * topY
      }px)`;
    },
    // 鼠标移出函数
    outHandler() {
      // 控制层罩与放大空间的隐藏
      this.topShow = false;
      this.rShow = false;
    }
  },
  mounted() {
    var picWidthEl = window.getComputedStyle(
      document.querySelector('.piczoom-masktop')
    );
    this.picWidth = parseInt(picWidthEl.width);
    this.picHeight = parseInt(picWidthEl.height);
    document
      .getElementsByTagName('body')[0]
      .style.setProperty('--width-zoom', this.picWidth / 2 + 'px');
    document
      .getElementsByTagName('body')[0]
      .style.setProperty('--height-zoom', this.picHeight / 2 + 'px');
    document
      .getElementsByTagName('body')[0]
      .style.setProperty('--size-zoom', this.zoom);
    var piczoomWidthEl = window.getComputedStyle(
      document.querySelector('.piczoom-top')
    );
    this.piczoomWidth = parseInt(piczoomWidthEl.width);
    this.piczoomHeight = parseInt(piczoomWidthEl.height);
  }
};
</script>

<style lang="scss">
/* 放大镜放大图片后，显示框的尺寸 */
:root {
  --width-zoom: 200px;
  --height-zoom: 200px;
  --size-zoom: 2;
}
$varWidth: var(--width-zoom);
$varHeight: var(--height-zoom);
.piczoom {
  width: 100%;
  height: 100%;
  /* 图片放大倍数 */
  .piczoom-right-img {
    width: calc(var(--width-zoom) * var(--size-zoom));
    height: calc(var(--height-zoom) * var(--size-zoom));
  }

  /* 放大图片后显示框的位置 */
  .piczoom-right {
    width: 100%;
    height: 100%;
    border: 1px solid red;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    right: -100%;
    overflow: hidden;
  }

  /* 原图的容器 */
  .piczoom-img-box {
    width: inherit;
    height: inherit;
    float: left;
    position: relative;
  }
  /* 移动放大镜的样式 */
  .piczoom-top {
    width: calc(var(--width-zoom) / 2);
    height: calc(var(--height-zoom) / 2);
    background-color: lightcoral;
    opacity: 0.4;
    position: absolute;
    top: 0;
    left: 0;
  }

  /* 制作一个顶层，用于限制移动放大镜的捕捉 和 范围 */
  .piczoom-masktop {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/piczoom.vue